const ReactDataGrid = require('react-data-grid');
const React = require('react');
import ReactDOM from 'react-dom';
import NetWorkErrorDateTimeRender from './NetWorkErrorDateTimeRender';

export default class NetWorkErrorLog extends React.Component {

  static textMap = {

    0:"网络连接错误 通常有以下几种情况:<br/>1.操作系统没有连接网络或服务器（或者上游代理）已关闭<br/>2.网络较差，此次请求未能正确建立基础连接 请注意此时通过网络标记查看也可以是有信号的<br/>3.网络较差，此次请求建立了正确的基础连接，但是不足以支撑此次请求的应用数据传输过程，最终断开<br/>4.网络较差，操作系统自动切换到了其认为可能更好的另外一个网络，比如从wifi1切换到了wifi2",

    400:"Bad Request <br/> 1、语义有误，当前请求无法被服务器理解。除非进行修改，否则客户端不应该重复提交这个请求。<br/> 2、请求参数有误。",

    401:"Unauthorized <br/> 当前请求需要用户验证。该响应必须包含一个适用于被请求资源的 WWW-Authenticate 信息头用以询问用户信息。<br/> 客户端可以重复提交一个包含恰当的 Authorization 头信息的请求。如果当前请求已经包含了 Authorization 证书，那么401响应代表着服务器验证已经拒绝了那些证书。如果401响应包含了与前一个响应相同的身份验证询问，且浏览器已经至少尝试了一次验证，那么浏览器应当向用户展示响应中包含的实体信息，因为这个实体信息中可能包含了相关诊断信息。",

    402:"Payment Required <br/> 此响应码保留以便将来使用，创造此响应码的最初目的是用于数字支付系统，然而现在并未使用。",

    403:"Forbidden <br/> 服务器已经理解请求，但是拒绝执行它。与 401 响应不同的是，身份验证并不能提供任何帮助，而且这个请求也不应该被重复提交。<br/> 如果这不是一个 HEAD 请求，而且服务器希望能够讲清楚为何请求不能被执行，那么就应该在实体内描述拒绝的原因。当然服务器也可以返回一个 404 响应，假如它不希望让客户端获得任何信息。",

    404:"Not Found <br/> 请求失败，请求所希望得到的资源未被在服务器上发现。<br/>没有信息能够告诉用户这个状况到底是暂时的还是永久的。假如服务器知道情况的话，应当使用410状态码来告知旧资源因为某些内部的配置机制问题，已经永久的不可用，而且没有任何可以跳转的地址。<br/>404这个状态码被广泛应用于当服务器不想揭示到底为何请求被拒绝或者没有其他适合的响应可用的情况下。",

    405:"Method Not Allowed <br/> 请求行中指定的请求方法不能被用于请求相应的资源。<br/>该响应必须返回一个Allow 头信息用以表示出当前资源能够接受的请求方法的列表。<br/>鉴于 PUT，DELETE 方法会对服务器上的资源进行写操作，因而绝大部分的网页服务器都不支持或者在默认配置下不允许上述请求方法，对于此类请求均会返回405错误。",

    406:"Not Acceptable <br/> 请求的资源的内容特性无法满足请求头中的条件，因而无法生成响应实体。",

    407:"Proxy Authentication Required <br/> 与401响应类似，只不过客户端必须在代理服务器上进行身份验证。代理服务器必须返回一个 Proxy-Authenticate 用以进行身份询问。客户端可以返回一个 Proxy-Authorization 信息头用以验证。",

    408:"Request Timeout <br/> 请求超时。客户端没有在服务器预备等待的时间内完成一个请求的发送。客户端可以随时再次提交这一请求而无需进行任何更改。",

    409:"Conflict <br/> 由于和被请求的资源的当前状态之间存在冲突，请求无法完成。<br/>这个代码只允许用在这样的情况下才能被使用：用户被认为能够解决冲突，并且会重新提交新的请求。该响应应当包含足够的信息以便用户发现冲突的源头。",

    410:"Gone <br/> 被请求的资源在服务器上已经不再可用，而且没有任何已知的转发地址。这样的状况应当被认为是永久性的。<br/>如果可能，拥有链接编辑功能的客户端应当在获得用户许可后删除所有指向这个地址的引用。<br/>如果服务器不知道或者无法确定这个状况是否是永久的，那么就应该使用 404 状态码。除非额外说明，否则这个响应是可缓存的。",

    411:"Length Required <br/> 服务器拒绝在没有定义 Content-Length 头的情况下接受请求。<br/>在添加了表明请求消息体长度的有效 Content-Length 头之后，客户端可以再次提交该请求。",

    412:"Precondition Failed <br/> 服务器在验证在请求的头字段中给出先决条件时，没能满足其中的一个或多个。<br/>这个状态码允许客户端在获取资源时在请求的元信息（请求头字段数据）中设置先决条件，以此避免该请求方法被应用到其希望的内容以外的资源上。",

    413:"Payload Too Large <br/> 服务器拒绝处理当前请求，因为该请求提交的实体数据大小超过了服务器愿意或者能够处理的范围。<br/>此种情况下，服务器可以关闭连接以免客户端继续发送此请求。如果这个状况是临时的，服务器应当返回一个 Retry-After 的响应头，以告知客户端可以在多少时间以后重新尝试。",

    414:"URI Too Long <br/> 请求的URI 长度超过了服务器能够解释的长度，因此服务器拒绝对该请求提供服务。<br/>这比较少见，通常的情况包括：本应使用POST方法的表单提交变成了GET方法，导致查询字符串（Query String）过长。",

    415:"Unsupported Media Type <br/> 对于当前请求的方法和所请求的资源，请求中提交的实体并不是服务器中所支持的格式，因此请求被拒绝。",

    416:"Requested Range Not Satisfiable <br/> 如果请求中包含了 Range 请求头，并且 Range 中指定的任何数据范围都与当前资源的可用范围不重合，<br/>同时请求中又没有定义 If-Range 请求头，那么服务器就应当返回416状态码。",

    417:"Expectation Failed <br/> 此响应代码意味着服务器无法满足 期望 请求标头字段指示的期望值。",

    418:"I’m a teapot <br/> 服务器拒绝尝试用 “茶壶冲泡咖啡”。",

    412:"Precondition Failed <br/> 该请求针对的是无法产生响应的服务器。<br/> 这可以由服务器发送，该服务器未配置为针对包含在请求 URI 中的方案和权限的组合产生响应。",

    422:"Unprocessable Entity (WebDAV) <br/> 请求格式良好，但由于语义错误而无法遵循。",

    423:"Locked (WebDAV) <br/> 正在访问的资源被锁定。",

    424:"Failed Dependency (WebDAV) <br/> 由于先前的请求失败，所以此次请求失败。",

    426:"Upgrade Required <br/> 服务器拒绝使用当前协议执行请求，但可能在客户机升级到其他协议后愿意这样做。<br/> 服务器在 426 响应中发送 Upgrade 头以指示所需的协议。",

    428:"Precondition Required <br/> 原始服务器要求该请求是有条件的。 旨在防止“丢失更新”问题，<br/>即客户端获取资源状态，修改该状态并将其返回服务器，同时第三方修改服务器上的状态，从而导致冲突。",

    429:"Too Many Requests <br/> 用户在给定的时间内发送了太多请求（“限制请求速率”）。",

    431:"Request Header Fields Too Large <br/> 服务器不愿意处理请求，因为它的 请求头字段太大（ Request Header Fields Too Large）。 <br/>请求可以在减小请求头字段的大小后重新提交。",

    451:"Unavailable For Legal Reasons <br/> 用户请求非法资源，例如：由政府审查的网页。",

    500:"Internal Server Error <br/> 服务器遇到了不知道如何处理的情况。通常服务器日志中会有异常栈",

    501:"Not Implemented <br/> 此请求方法不被服务器支持且无法被处理。只有GET和HEAD是要求服务器支持的，它们必定不会返回此错误代码。",

    502:"Bad Gateway <br/> 此错误响应表明服务器作为网关需要得到一个处理这个请求的响应，但是得到一个错误的响应。",

    503:"Service Unavailable <br/> 服务器没有准备好处理请求。 常见原因是服务器因维护或重载而停机。 <br/>请注意，与此响应一起，应发送解释问题的用户友好页面。 这个响应应该用于临时条件和 Retry-After：如果可能的话，HTTP头应该包含恢复服务之前的估计时间。 <br/>网站管理员还必须注意与此响应一起发送的与缓存相关的标头，因为这些临时条件响应通常不应被缓存。",

    504:"Gateway Timeout <br/> 当服务器作为网关，不能及时得到响应时返回此错误代码。",

    505:"HTTP Version Not Supported <br/> 服务器不支持请求中所使用的HTTP协议版本。",

    506:"Variant Also Negotiates <br/> 服务器有一个内部配置错误：对请求的透明内容协商导致循环引用。",

    507:"Insufficient Storage <br/> 服务器有内部配置错误：所选的变体资源被配置为参与透明内容协商本身，因此不是协商过程中的适当端点。",

    508:"Loop Detected (WebDAV) The server detected an infinite loop while processing the request. <br/> 服务器在处理请求时检测到无限循环。",

    510:"Not Extended <br/> 服务器需要对请求进一步扩展才能实现它。",

    511:"Network Authentication Required <br/> 客户端需要进行身份验证才能获得网络访问权限。"
  };

  constructor(props) {
    super(props);
    
    var columns=[
        {
            key: 'className',
            name: "画面",
            width: 137,
            resizable: true
        },
        {
            key: 'methodName',
            name: "方法",
            width:200,
            resizable: true
        },
        {
            key: 'startDateTime',
            name: "发生时间",
            width:200,
            resizable: true,
            formatter:<NetWorkErrorDateTimeRender/>
        },
        {
            key: 'readyState',
            name: "浏览器响应状态",
            width:100,
            resizable: true
        },
        {
            key: 'state',
            name: "浏览器响应描述",
            width:136,
            resizable: true
        },
        {
            key: 'httpStatus',
            name: "HTTP响应状态",
            width:100,
            resizable: true
        },
        {
            key: 'statusText',
            name: "HTTP响应描述",
            width:136,
            resizable: true
        },
        {
            key: 'duration',
            name: "耗时(ms)",
            width:136,
            resizable: true
        }

    ];
    
    this.columns = columns;
    this.state ={
      rows:this.props.fdataProvider, 
      selectedIndexes: [0],
      fdataProvider: {},
      title: this.props.title,
    }

  }
  

  static show(fdataProvider, title) {
    
      ReactDOM.render(
        
        <NetWorkErrorLog fdataProvider={fdataProvider}  title={title} />
        
        ,document.getElementById('netWorkErrorInfoModal')
      )
      
  }
  componentDidMount(){
    $(this.netWorkErrorLogContainer).draggable({
      handle: ".modal-header" // 只能点击头部拖动
    }); //为模态对话框添加拖拽

    $("#netWorkErrorInfoModal").css("display","flex");   
    let index = this.state.selectedIndexes[0];
    if(index == -1 || index == undefined)
      index = 0;
    let data = this.state.rows[0];
    if(data)
      $(this.reasonDiv).html(NetWorkErrorLog.textMap[data.httpStatus]);
  }

  close=()=>
  {
    let $reactComponentContainer = $("#netWorkErrorInfoModal");
    ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
    //$reactComponentContainer.remove();
    $("#netWorkErrorInfoModal").css("display","none");
  }

  
  getRowAt = (index) => {
    if (index < 0 || index > this.getSize()) {
      return undefined;
    }

    return this.state.rows[index];

  };

  getSize = () => {
    return this.state.rows.length;
  };

  rowClick = (index,record,proxy) =>{

    this.setState({ selectedIndexes:[index]});
  }

  gridKeyDown(proxy)
  {
    //console.log(arguments);
    if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
    {
      let ne = proxy["nativeEvent"];
     
      if(ne.keyCode == 40 || ne.keyCode == 38)
      {
        let record = null;
        var newSelectIndexes = this.state.selectedIndexes.slice();
        if(newSelectIndexes.length == 0)
        {
          if(this.state.rows.length>0)
          {
            record = ne.keyCode == 40?this.state.rows[0]:this.state.rows[this.state.rows.length-1];
            newSelectIndexes.push(0);
          }
        }
        else
        {
          let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
          let newIndex = ne.keyCode==40?lastIndex+1:lastIndex-1;
          let total = this.state.rows.length;
          if(newIndex>=0&&newIndex<total)
          {
            record = this.state.rows[newIndex];
            newSelectIndexes = [newIndex];
          }
        }
        
        this.setState({selectedIndexes:newSelectIndexes});
        return true;
      }
     
    }
  }
  /** 
   *  <div className="modal-header" style={{background:"#ffffff",padding:"10px",position:"relative"}}>
                <i className="fa fa-close" style={{position: 'absolute',top: '13px', right: '10px', fontSize: '15px', cursor: 'pointer'}}  onClick={this.close.bind(this)}></i>
                <h5 className="modal-title" style={{fontWeight:'bolder'}}>{this.state.title}</h5>
            </div>

  */
  render() {  

    return (
          <div ref={node=>this.netWorkErrorLogContainer=node} tabIndex="-1"  style={{position:'absolute',alignSelf:"center",borderRadius:"2px",backgroundColor:'white',width:'750px',height:'500px',display:'flex',flexDirection:'column',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)'	}}>
            <div className="modal-header" style={{background:"#ffffff",padding:"10px",position:"relative",paddingTop:'13px',paddingBottom:'13px',backgroundColor:'#F8F8F8'}}>
              <div className="modal-close" onClick={this.close.bind(this)}></div>
              <h5 className="modal-title" style={{fontFamily:'STSongti-SC-Bold',fontSize:'16px',color:'#000000',fontWeight:'500 !IMPORTANT'}}>{this.state.title}</h5>
            </div>
           
            <div style={{display:'flex',flexDirection:'column',flexGrow:100,padding:'5px'}}>
               
                    <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch'}} ref={node=>this.gridContainer=node}>
                    
                        <ReactDataGrid        
                          ref={ node => this.grid = node }
                          // onGridSort={this.handleGridSort}
                          enableCellSelect={true}
                          columns={this.columns}//columns={this.state.columns}
                          // columns={this.props.columns}
                          // columns={this.getColumns()}
                          rowGetter={this.getRowAt}
                          rowsCount={this.getSize()}
                          //onGridRowsUpdated={this.handleGridRowsUpdated}
                          // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
                          enableRowSelect={false}
                          onGridKeyDown={this.gridKeyDown.bind(this)}
                          rowSelection={{
                          showCheckbox: false,
                          selectBy: {
                              indexes: this.state.selectedIndexes
                              
                          }
                          }}
                          onRowClick={this.rowClick}//this.rowClick this.rowClick.bind(this)
                          rowHeight={30}
                          minHeight={310}
                          rowScrollTimeout={500} 
                          cellNavigationMode="loopOverRow"
                          
                          />
                    </div>
               
              <div style={{display:'flex',flexDirection:'column',flexGrow:0,padding:'4px 0'}}>
                <label>原因分析</label>
                <div ref={node=>this.reasonDiv=node}></div>
              </div>
          </div>

          
         </div>);
        
  }
}



// WEBPACK FOOTER //
// ./src/networkerror/NetWorkErrorLog.js